<div *ngIf="loaded">
  <div id="ap-tiny-editor-container"
       class="ap-editor-container"
       [ngClass]="{'required': required, 'required-invalid': parentForm?.submitted && innerControl?.invalid}">
    <div [collapse]="!hasWarning"
         [isAnimated]="false">
      <span id="ap-tiny-editor-warning"
            class="ap-editor-warning alert alert-warning alert-dismissible"
            role="alert">
        <span class="ap-editor-warning-text"
              [innerHTML]="warningMessage"></span>
        <div id="ap-tiny-editor-warning-close-x"
             class="close"
             (click)="closeWarning()">&times;</div>
      </span>
    </div>
    <editor #editorInstance
            [id]="editorId"
            [init]="tinymceOptions"
            [formControl]="innerControl"
            [apCVAViewToModelChange]="this"
            (onDirty)="onDirty()">
    </editor>
    <div class="incorrect-input"
         *ngIf="required && parentForm?.submitted && innerControl?.invalid">
      {{(displayName || editorName) + ' is a required field'}}
    </div>
  </div>
</div>
